export enum AuthEvents {
    LOGIN = "LOGIN",
    LOGOUT = "LOGOUT",
    TOKEN_REFRESH_DATE = "TOKEN_REFRESH_DATE",
    ACTIVE_PAGE_LOAD_DATE = "ACTIVE_PAGE_LOAD_DATE",
    VERIFICATION_SENDING_TIME = "VERIFICATION_SENDING_TIME",
    EMAIL_CONFIRMED_TIME = "EMAIL_CONFIRMED_TIME"
}
